import type { TabKey } from "@/lib/api/types";

/** 상단 탭 한 벌. 라벨과 주소는 여기에만 산다 — 서버는 "감춰도 되는 키" 만 판정한다
 *  (`api/models/user.py` 의 `TabKey`). 탭을 더할 때 두 곳을 같이 고쳐야 하고,
 *  그러지 않으면 새 탭은 감출 수 없다.
 *
 *  `AppShell`(무엇을 그릴까)과 설정 화면(무엇을 끌 수 있을까)이 같이 쓴다. 두 벌이
 *  되면 설정에서 끈 탭이 그대로 남아 있거나, 그 반대가 된다. */
export const TABS: Array<{ key: TabKey; to: string; label: string }> = [
  { key: "order", to: "/", label: "주문" },
  { key: "people", to: "/people", label: "명단" },
  { key: "menuboards", to: "/menuboards", label: "메뉴판" },
  { key: "toast", to: "/toast", label: "건배사" },
  { key: "icebreaker", to: "/icebreaker", label: "대화 주제" },
  { key: "draw", to: "/draw", label: "내기" },
];

/** 감춘 것을 걸러 낸 탭. 감춤은 **화면 정리일 뿐 권한이 아니다** — 주소를 직접 치면
 *  그대로 열린다(라우트를 지우지 않는다).
 *
 *  모르는 키는 무시한다: 탭을 없앤 뒤에도 옛 설정이 서버에 남아 있을 수 있고,
 *  그때 남은 키가 다른 탭을 지워 버리면 안 된다.
 *
 *  전부 감추면 탭 줄이 빈다. 그래도 설정 입구는 헤더에 늘 있어서 되돌릴 수 있다 —
 *  그래서 "최소 한 개" 규칙을 두지 않는다(끄고 싶은 사람의 화면을 우리가 정하지 않는다). */
export function visibleTabs(hidden: readonly string[] = []): typeof TABS {
  const off = new Set(hidden);
  return TABS.filter((tab) => !off.has(tab.key));
}
